// Safety net for errors React error boundaries cannot see: exceptions thrown in event handlers, timers and
// promises (window 'error' + 'unhandledrejection'). Plain DOM on purpose — it must work even when React is broken.
// Shows the same "Something went wrong — reload" panel as TabErrorBoundary, with the message, the stack and the
// bundle that is running (main.<hash>.js) so a report always says which build threw. Dismissible: the app underneath
// is left alone, because a stray rejection should not hide a working screen.
const IGNORED = /ResizeObserver loop|^Script error\.?$/i;

function bundleName() {
  const s = [...document.scripts].map(x => x.src).find(u => /\/static\/js\/main\.[^/]+\.js/.test(u));
  return s ? s.split('/').pop() : 'unknown bundle';
}

function show(kind, err) {
  const message = String((err && err.message) || err || 'Unknown error');
  if (IGNORED.test(message)) return;
  const stack = String((err && err.stack) || '').slice(0, 800);
  console.error(`[timbo] ${kind}:`, err);
  let host = document.getElementById('timbo-global-error');
  if (!host) {
    host = document.createElement('div');
    host.id = 'timbo-global-error';
    host.setAttribute('role', 'alert');
    host.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:10000;width:min(640px,calc(100vw - 32px));max-height:70vh;overflow:auto;box-sizing:border-box;padding:20px;border:1px solid #c0392b;border-radius:12px;background:#fff;color:#111;box-shadow:0 12px 40px rgba(0,0,0,.25);font:13px "DM Sans",sans-serif';
    document.body.appendChild(host);
  }
  host.textContent = '';
  const add = (tag, css, text) => { const el = document.createElement(tag); el.style.cssText = css; el.textContent = text; host.appendChild(el); return el; };
  add('div', 'font-size:16px;font-weight:700;color:#c0392b;margin-bottom:8px', 'Something went wrong — reload');
  add('div', 'margin-bottom:6px', message);
  add('div', 'font-size:11px;color:#777;margin-bottom:8px', `${kind} · ${bundleName()}`);
  if (stack) add('pre', 'font-size:11px;color:#555;white-space:pre-wrap;margin:0 0 14px', stack);
  const row = add('div', 'display:flex;gap:8px', '');
  const btn = (label, css, fn) => { const b = document.createElement('button'); b.textContent = label; b.style.cssText = `padding:7px 16px;border-radius:8px;font:600 13px "DM Sans",sans-serif;cursor:pointer;${css}`; b.onclick = fn; row.appendChild(b); };
  btn('Reload', 'border:none;background:#ff7900;color:#fff', () => window.location.reload());
  btn('Dismiss', 'border:1px solid #ccc;background:#fff;color:#444', () => host.remove());
}

export function installGlobalErrorPanel() {
  if (window.__timboErrorPanel) return;
  window.__timboErrorPanel = true;
  window.addEventListener('error', (e) => show('Uncaught error', e.error || e.message));
  window.addEventListener('unhandledrejection', (e) => show('Unhandled promise rejection', e.reason));
}
